//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//api
import { api } from '../../../../functions/api';

//custom components
import CustomInput from '../../../../components/basic/input';

//material-ui
import { Grid, Paper, FormControl, Select, InputLabel, MuiThemeProvider, createMuiTheme, MenuItem } from '@material-ui/core'

//other libraries

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiFormLabel: {
            focused: {
                color: "#777777 !important"
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottomColor: "#777777 !important"
                }
            }
        },
        MuiFormControl: {
            root: {
                marginBottom: "10px"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class ContactInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            country: ""
        }
    }

    componentDidMount() {
        let shopDetail = toJS(this.props.internal.dataForTable)
        if(shopDetail.country_id !== null) {
            this.setState({country: shopDetail.country_id})
        }
    }

    timeout = null

    handleOnChange = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateData()
        }, 500)
    }

    updateData = async() => {

        let params = {
            street_name: this.street_name.state.value,
            street_no: this.street_no.state.value,
            zip: this.zip.state.value,
            city: this.city.state.value,
            country_id: this.state.country,
            contact_email: this.contact_email.state.value,
            contact_phone: this.contact_phone.state.value,
            latitude: this.latitude.state.value,
            longitude: this.longitude.state.value,
            facebook: null,
            instagram: null,
            google: null,
            twitter: null,
            youtube: null,
        }

        if(this.facebook.state.value !== "") {
            params.facebook = "https://" + this.facebook.state.value
        }

        if(this.instagram.state.value !== "") {
            params.instagram = "https://" + this.instagram.state.value
        }

        if(this.google.state.value !== "") {
            params.google = "https://" + this.google.state.value
        }

        if(this.twitter.state.value !== "") {
            params.twitter = "https://" + this.twitter.state.value
        }

        if(this.youtube.state.value !== "") {
            params.youtube = "https://" + this.youtube.state.value
        }

        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'PATCH',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(update_data.success === true) {
            this.props.internal.setDataForTable(update_data.data.data)
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            let resultError = ""
            for(let err in update_data.data.data.errors) {
                // if(err === 'latitude') {
                //     resultError += this.props.translate.i18n.GLOBAL.CONTACT.LATITUDE + " " + this.props.translate.i18n.GLOBAL.ALERTS.VALUE_MUST_BE_NUMBER + " "
                // }
                // else if(err === "longitude") {
                //     resultError += this.props.translate.i18n.GLOBAL.CONTACT.LONGITUDE + " " + this.props.translate.i18n.GLOBAL.ALERTS.VALUE_MUST_BE_NUMBER + " "
                // }
                // else {
                //     resultError += update_data.data.data.errors[err] + " "
                // }
                resultError += update_data.data.data.errors[err] + " "
                
            }
            this.props.internal.setSnackbar(resultError, true)
        }
    }

    handleChangeCountry = (e) => {
        this.setState({country: e.target.value}, () => this.updateData())
    }

    render () {
        return (
            <MuiThemeProvider theme={theme}>
            <div className={'shopDetailContainer'}>
            <div className="content">
                <Grid container spacing={16} >
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.street_name = ref)}
                                text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                value={toJS(this.props.internal.dataForTable.street_name)}
                                id={"street_name"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.street_no = ref)}
                                text={this.props.translate.i18n.GLOBAL.ADRESS.STREET_NO}
                                value={toJS(this.props.internal.dataForTable.street_no)}
                                id={"street_no"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.zip = ref)}
                                text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                value={toJS(this.props.internal.dataForTable.zip)}
                                id={"zip"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.city = ref)}
                                text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                value={toJS(this.props.internal.dataForTable.city)}
                                id={"city"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            {/* <CustomInput
                                ref={ref => (this.country = ref)}
                                text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                                value={this.props.internal.dataForTable.country !== null ? toJS(this.props.internal.dataForTable.country.name) : ""}
                                id={"country"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            /> */}
                            <FormControl className={'w-100'}>
                                <InputLabel htmlFor="country">{this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}</InputLabel>
                                <Select
                                    className={'w-100'}
                                    value={this.state.country}
                                    onChange={this.handleChangeCountry}
                                    inputProps={{
                                        name: 'country',
                                        id: 'country',
                                    }}
                                >
                                    {this.props.internal.countries.map((country, index) => {
                                        return (
                                            <MenuItem key={country.id} value={country.id} id={country.id}>{country.name}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.facebook = ref)}
                                text="Facebook"
                                value={toJS(this.props.internal.dataForTable.facebook) !== null ? toJS(this.props.internal.dataForTable.facebook).replace("https://", "") : ""}
                                id={"facebook"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                startAdornment={{
                                    position: "start", value: "https://"
                                }}
                            />
                            <CustomInput
                                ref={ref => (this.instagram = ref)}
                                text="Instagram"
                                value={toJS(this.props.internal.dataForTable.instagram) !== null ? toJS(this.props.internal.dataForTable.instagram).replace("https://", "") : ""}
                                id={"instagram"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                startAdornment={{
                                    position: "start", value: "https://"
                                }}
                            />
                            <CustomInput
                                ref={ref => (this.youtube = ref)}
                                text="YouTube"
                                value={toJS(this.props.internal.dataForTable.youtube) !== null ? toJS(this.props.internal.dataForTable.youtube).replace("https://", "") : ""}
                                id={"youtube"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                startAdornment={{
                                    position: "start", value: "https://"
                                }}
                            />
                            <CustomInput
                                ref={ref => (this.twitter = ref)}
                                text="Twitter"
                                value={toJS(this.props.internal.dataForTable.twitter) !== null ? toJS(this.props.internal.dataForTable.twitter).replace("https://", "") : ""}
                                id={"twitter"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                startAdornment={{
                                    position: "start", value: "https://"
                                }}
                            />
                            <CustomInput
                                ref={ref => (this.google = ref)}
                                text="Google"
                                value={toJS(this.props.internal.dataForTable.google) !== null ? toJS(this.props.internal.dataForTable.google).replace("https://", "") : ""}
                                id={"google"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                startAdornment={{
                                    position: "start", value: "https://"
                                }}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.contact_email = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.CONTACT_EMAIL}
                                value={toJS(this.props.internal.dataForTable.contact_email)}
                                id={"contact_email"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.contact_phone = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.CONTACT_PHONE}
                                value={toJS(this.props.internal.dataForTable.contact_phone)}
                                id={"contact_phone"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.latitude = ref)}
                                text={this.props.translate.i18n.GLOBAL.CONTACT.LATITUDE}
                                value={toJS(this.props.internal.dataForTable.latitude)}
                                id={"latitude"}
                                className={"w-100"}
                                align={'right'}
                                change={this.handleOnChange}
                                type={"number"}
                            />
                            <CustomInput
                                ref={ref => (this.longitude = ref)}
                                text={this.props.translate.i18n.GLOBAL.CONTACT.LONGITUDE}
                                value={toJS(this.props.internal.dataForTable.longitude)}
                                id={"longitude"}
                                className={"w-100"}
                                align={'right'}
                                change={this.handleOnChange}
                                type={"number"}
                            />
                        </Paper>
                    </Grid>
                </Grid>
                </div>
            </div>
            </MuiThemeProvider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/shops/detail/ContactInfo2/ContactInfo2.jsx